<template>
  <div class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" />
          <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <p>{{ question }}</p>
            </div>
          </div>
          <slot></slot>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="confirmed()" data-dismiss="modal">Yes</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: ['title', 'question'],
    methods: {
      confirmed() {
        this.$emit('confirmed');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ConfirmationModal.vue?6bb938a8